import React from 'react';

import withSizes from 'react-sizes';

import {
  RollUpClickableTitle,
  WrapBannerImageWithHref,
} from '../../../../shared';
import { BannerDescription } from './BannerDescription';

const mapSizesToProps = ({ width }) => ({
  winW: width
})

class HearingAndVisionImpairmentsV2 extends React.Component {
  bannerImgSrc() {
    const path = '/img/2024/04/HearingAndVisionImpairmentsV2';

    return this.props.winW >= 1024
      ? `${path}/dt.jpg`
      : `${path}/mob.png`
  }

  promoLink = ''

  render() {
    return (
      <div className='mp__sertificat'>
        <div className='wd'>
          <div className='sertificat'>
            <WrapBannerImageWithHref href={this.promoLink} src={this.bannerImgSrc()} />
            <RollUpClickableTitle title='ЯК ЦЕ ПРАЦЮЄ?' />
            <BannerDescription promoLink={this.promoLink} />
          </div>
        </div>
      </div>
    )
  }
}

export default withSizes(mapSizesToProps)(HearingAndVisionImpairmentsV2)



// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/HearingAndVisionImpairmentsV2/impl/HearingAndVisionImpairmentsV2.jsx